export default function toPhoneNumber(value) {
        let cleaned = ('' + value).replace(/\D/g, '');

        let match = cleaned.match(/^(\d{3})(\d{3})(\d*)$/);
      
        if (match) {
          return '(' + match[1] + ')' + match[2] + '-' + match[3]
        }
      
        return null
}